'use strict';

import get from 'lodash/get';
import includes from 'lodash/includes';
import {PlatformType} from '@techsee/techsee-common/lib/constants/utils.constant';
import {TraceLevel, TraceOutputData} from '@techsee/techsee-common/lib/core/Tracer';
import {LOG_EVENTS} from '@techsee/techsee-common/lib/constants/event-logs.constants';
import {getRootStore} from '../../app.bootstrap';

export interface ITsExtraLoggingService {
    init(account: object, eventLog: any): void;
    traceToEventLogOutputFunction(traceData: TraceOutputData): Promise<void>;
}

export class TsExtraLoggingService implements ITsExtraLoggingService {
    private _eventLog: any;

    private _enabled: boolean = true;

    private _logOnlySpecifiedCategories: boolean = false;

    private _logCategories?: [string] | null;

    constructor() {
        this.traceToEventLogOutputFunction = this.traceToEventLogOutputFunction.bind(this);
    }

    private serializeValue(value: any): any {
        try {
            if (value instanceof Error) {
                return {
                    message: value.message,
                    stack: value.stack,
                    ...((value as any).status ? {status: (value as any).status} : {}),
                    ...((value as any).response?.status ? {responseStatus: (value as any).response.status} : {})
                };
            }

            return value;
        } catch {
            return {message: String(value)};
        }
    }

    init(account: object, eventLog: any) {
        if (account) {
            this._enabled = !!get(account, 'protectedSettings.verboseLogging.enabled');
        }

        this._eventLog = eventLog;
        this._logOnlySpecifiedCategories = !!get(
            account,
            'protectedSettings.verboseLogging.logOnlySpecifiedCategories'
        );
        // @ts-ignore
        this._logCategories = (get(account, 'protectedSettings.verboseLogging.categories') as string[]) || [];
    }

    traceToEventLogOutputFunction(traceData: TraceOutputData): Promise<void> {
        if (
            !this._enabled ||
            traceData.traceLevel === TraceLevel.Debug ||
            (this._logOnlySpecifiedCategories &&
                this._logCategories !== null &&
                !includes(this._logCategories, traceData.tracerNamePostfix))
        ) {
            return Promise.resolve();
        }

        const metaData = {
            side: PlatformType.dashboard,
            logType: traceData.traceLevel === TraceLevel.Error ? LOG_EVENTS.traceErr.type : LOG_EVENTS.trace,
            verboseLogging: this._enabled,
            verboseLogType: traceData.tracerName + ':' + traceData.tracerNamePostfix,
            message: traceData.message,
            details: Array.isArray(traceData.optionalData)
                ? traceData.optionalData.map((v) => this.serializeValue(v))
                : traceData.optionalData,
            traceLevel: traceData.traceLevel,
            sourceUrl: window.location.href,
            clientVersion: CLIENT_VERSION
        };

        return this._eventLog
            .trace(metaData)
            .catch((err: any) =>
                console.error(
                    ' >> send trace as eventlog failed: >> msg:' +
                        traceData.message +
                        ' >> err: ' +
                        err +
                        ' >> metaData' +
                        JSON.stringify(metaData)
                )
            );
    }
}
